import { useContext } from 'react';
import QRCodeContext from './QRCodeContext';
import QRCodeProvider from './QRCodeProvider';

export const useQRCodeContext = () => useContext(QRCodeContext);
export default QRCodeProvider;
